import Api from '../../../shared/Api';

class ScandphotosOrdersApi {
    static getOrders(): any {
        return new Api().get('/views/scandphotos/orders');
    }

    static newOrder(
        pendingOrderId?: string,
        orderCollectionId?: number,
        newPendingOrder?: boolean
    ): any {
        return new Api().get('/views/scandphotos/orders/new', {
            pendingOrderId,
            orderCollectionId,
            newPendingOrder
        });
    }

    static firmDetails(firmId: number): any {
        return new Api().get(`/views/scandphotos/orders/new/firm-details?firmId=${firmId}`);
    }

    static createOrder(orderInfo: any, calendarItem: any, orderCollectionId?: number): any {
        let payload = orderInfo;
        payload.calendarItem = calendarItem;

        return new Api().post(
            '/views/scandphotos/orders' +
                (orderCollectionId ? '?orderCollectionId=' + orderCollectionId : ''),
            payload
        );
    }
}

export default ScandphotosOrdersApi;
